import React from "react";
import { TemplateContext } from "./context";

export const useTemplate = () => {
  const context = React.useContext(TemplateContext);

  return context;
};
